<template>
  <div :class="[{ 'container': !fluid, 'container-fluid': fluid }]">
    <header
      v-if="showTitle"
      class="row"
    >
      <slot name="title" />
    </header>
    <slot class="row" />
  </div>
</template>

<script>
  export default {
    name: "OneColumn",
    props: {
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      },
      fluid: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~assets/styles/common.scss";
  @import "~assets/styles/bootstrap-grid.scss";

  .container, .container-fluid {
    margin-bottom: 32px;

    @include bp-mf-desktop {
      margin-bottom: 64px;
    }
  }

  .container-fluid {
    padding: 0;

    [class*="col-"] {
      padding: 0;
    }
  }
</style>
